/**
 * The id the root skip link aims at, and that a layout's `<main>` carries
 * (#14982). Kept out of `skip-to-main-content.tsx` because that module is
 * `'use client'`: a server component importing a constant from it receives a
 * client reference, not the string (#14268).
 */
export const MAIN_CONTENT_ID = 'main-content'
